module.exports = __webpack_public_path__ + "assets/img/footer_logo_8.d81f0e7c.png";